import { render, staticRenderFns } from "./ProductPromos.vue?vue&type=template&id=df3bc4a4"
import script from "./ProductPromos.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPromos.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductPromos.vue?vue&type=style&index=0&id=df3bc4a4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports